import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { chgInstance } from "../../redux/ReduxInstance";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import ComponentSousmenusList from "../../components/admin/sousmenus/ComponentSousmenusList";
import { Container, Tabs, Tab } from "react-bootstrap";
import { apiGetInstance, apiUpdateInstance } from "../../api/ApiInstance";
import { useTranslation } from "react-i18next";

const PageAdminSousMenus = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  const dispatch = useDispatch();
  const [state, setState] = useState(ReduxInstance.sousMenus);

  const submitData = async (idSousmenu, saisie) => {
    const stateCopy = [...state];

    if (idSousmenu !== "") {
      stateCopy[idSousmenu] = saisie;
    } else {
      stateCopy.push(saisie);
    }
    setState(stateCopy);

    const formData = { sousMenus: stateCopy };
    await apiUpdateInstance(ReduxInstance._id, formData);
    const res = await apiGetInstance(ReduxInstance._id, ReduxUserEmail);
    dispatch(chgInstance(res.data));
  };

  const submitDelete = async (idSousmenu) => {
    if (idSousmenu !== "") {
      const stateCopy = [...state];
      stateCopy.splice(idSousmenu, 1);
      setState(stateCopy);
      const formData = { sousMenus: stateCopy };
      await apiUpdateInstance(ReduxInstance._id, formData);
      const res = await apiGetInstance(ReduxInstance._id, ReduxUserEmail);
      dispatch(chgInstance(res.data));
    }
  };

  const changeOrdre = async (index, direction, parent) => {
    const stateCopy = [...state];
    const indexOrigine = index;
    let indexTarget = index;

    /* on va determiner l'index le plus grand ou petit de la categorie en cours */
    if (direction === "bas") {
      let trouve = 0;
      stateCopy.forEach((element, index) => {
        if (
          index > indexOrigine &&
          trouve === 0 &&
          element.parent === parent &&
          indexOrigine !== 0
        ) {
          indexTarget = index;
          trouve = 1;
        }
      });
    }
    if (direction === "haut") {
      stateCopy.forEach((element, index) => {
        if (index < indexOrigine && element.parent === parent) {
          indexTarget = index;
        }
      });
    }

    const saveObjectOrigine = stateCopy[indexOrigine];
    const saveObjectTarget = stateCopy[indexTarget];

    stateCopy[indexOrigine] = saveObjectTarget;
    stateCopy[indexTarget] = saveObjectOrigine;

    const formData = { sousMenus: stateCopy };
    await apiUpdateInstance(ReduxInstance._id, formData);
    const res = await apiGetInstance(ReduxInstance._id, ReduxUserEmail);
    if (res.data) {
      setState(stateCopy);
      dispatch(chgInstance(res.data));
    }
  };

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminSousMenus.titre")} />
        <Tabs defaultActiveKey="inGovernance" className="mb-3">
          <Tab eventKey="inGovernance" title={t("admin.PageAdminSousMenus.tabTitre1")}>
            <ComponentSousmenusList
              handleSubmitDelete={submitDelete}
              handleSubmitData={submitData}
              parent="inGovernance"
              stateFromParent={state}
              changeOrdre={changeOrdre}
            />
          </Tab>
          <Tab eventKey="inSocial" title={t("admin.PageAdminSousMenus.tabTitre2")}>
            <ComponentSousmenusList
              handleSubmitDelete={submitDelete}
              handleSubmitData={submitData}
              parent="inSocial"
              stateFromParent={state}
              changeOrdre={changeOrdre}
            />
          </Tab>
          <Tab eventKey="inOperation" title={t("admin.PageAdminSousMenus.tabTitre3")}>
            <ComponentSousmenusList
              handleSubmitDelete={submitDelete}
              handleSubmitData={submitData}
              parent="inOperation"
              stateFromParent={state}
              changeOrdre={changeOrdre}
            />
          </Tab>
          <Tab eventKey="inViews" title={t("admin.PageAdminSousMenus.tabTitre4")}>
            <ComponentSousmenusList
              handleSubmitDelete={submitDelete}
              handleSubmitData={submitData}
              parent="inViews"
              stateFromParent={state}
              changeOrdre={changeOrdre}
            />
          </Tab>
          <Tab eventKey="espaces" title={t("admin.PageAdminSousMenus.tabTitre5")}>
            <ComponentSousmenusList
              handleSubmitDelete={submitDelete}
              handleSubmitData={submitData}
              parent="espaces"
              stateFromParent={state}
              changeOrdre={changeOrdre}
            />
          </Tab>
        </Tabs>
      </Container>
    </>
  );
};

export default PageAdminSousMenus;
